/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { ZencityComponent } from "cms/components/components/zencity/display/zencity";
import { isStringNotEmpty } from "utils/empty-exists";

const ZencityComponentDisplay = () => {
    
    const ctx = useContext(ContentZoneContext);
    const component = ctx.component;

    const { project, topic } = component;
    const hasTopic = isStringNotEmpty(topic);
    const hasProject = isStringNotEmpty(project);
    const hasContent = hasTopic && hasProject;
    
    if (!hasContent) {
        return (
            <EmptyContentMessage 
                component={component}
            />
        );
    }

    return (
        <>
            <h2>Zencity Engage</h2>
            <ZencityComponent
                component={component}
            />
        </>
    );
};

ZencityComponentDisplay.displayName = "ZencityComponentDisplay";
export { ZencityComponentDisplay };

